import React from "react";
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    CardMedia,
    Typography,
} from "@mui/material";
import CourseEnrolmentDetails from "./CourseEnrolmentDetails";

import "react-circular-progressbar/dist/styles.css";

import { Link } from "react-router-dom";
import DayJS from "react-dayjs";
import SkillChip from "../SkillChip";
import TMSAvatar from "../TMSAvatar";

const DurationText = ({ duration }) => {
    let displayDuration = "";
    const durationNumber = parseInt(duration);

    if (durationNumber > 0) {
        let hours = Math.floor(Number(durationNumber) / 60);
        let minutes = Number(durationNumber) % 60;
        if (hours > 0) {
            displayDuration = ` (${hours} hr`;
            if (hours > 1) {
                displayDuration += `s`;
            }
            if (minutes > 0) {
                displayDuration += ` ${minutes} min`;
            }
            displayDuration += `)`;
        } else if (minutes > 0) {
            displayDuration = ` (${minutes} min)`;
        }
    }

    return displayDuration;
};

function CourseCard({ course }) {
    const title = course?.name ?? "Course";
    const code = course?.code ?? "-";
    const image = course?.image ?? "";
    const validFrom = course?.validFrom ?? "";

    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={"/tms/courses/" + course?.id}
                centerRipple={true}
            >
                {image.length > 16 && (
                    <CardMedia
                        component="img"
                        height="250"
                        image={image}
                        alt=""
                    />
                )}
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <TMSAvatar
                            type="course"
                            badge={
                                course?.enrolment?.status === "completed"
                                    ? "checked"
                                    : course?.enrolment?.status === "enrolled"
                                    ? "checked-blue"
                                    : ""
                            }
                        />
                    }
                    title={
                        <Typography
                            component="h3"
                            className="card-header-title"
                        >
                            {title} - {code}
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            Released on{" "}
                            <DayJS format="DD MMM YYYY">{validFrom}</DayJS>
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <Box className="card-content">
                    <Typography variant="body1">
                        {course?.description}
                    </Typography>
                </Box>
            </CardContent>
            {!!course.skill && (
                <CardContent>
                    <Box className="card-content">
                        <SkillChip label={course.skill?.name} />
                    </Box>
                </CardContent>
            )}
            <CardContent>
                <Box className="card-content">
                    {course?.modules?.length > 0 && (
                        <Typography variant="p">
                            This course consists of {course.modules.length}
                            {course.modules.length > 1 ? " modules" : " module"}
                            .
                            <DurationText duration={course.duration} />
                        </Typography>
                    )}
                    {course?.modules?.length < 1 && (
                        <Typography variant="p">
                            Modules have not been defined.
                        </Typography>
                    )}
                </Box>
            </CardContent>
            {!!course && <CourseEnrolmentDetails course={course} />}
        </Card>
    );
}

export default CourseCard;
